<template>
  <div class="overflow-x-scroll no-scrollbar flex">
    <div
      v-for="item in items"
      :key="`${client.id}-${item}`"
      class="relative whitespace-nowrap font-normal bg-primary px-4 py-1 mr-3 rounded"
    >
      {{ item }}
      <div v-if="allowEditing" class="px-1 py-1 absolute -right-2 -top-0.5">
        <FontAwesomeIcon
          :icon="['fas', 'trash']"
          size="xs"
          class="text-gray cursor-pointer"
          @click="removeItem(item)"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HorizontalList",
  components: {},
  props: {
    items: {
      type: Array,
      default: () => []
    },
    client: {
      type: Object,
      default: () => {}
    },
    allowEditing: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: null
    }
  },
  computed: {},
  data() {
    return {
      import_to_file: ""
    };
  },
  methods: {
    removeItem(item) {
      this.$emit("delete", {
        type: this.type,
        item
      });
    }
  },
  created() {}
};
</script>

<style></style>
